jqCustom = jQuery.noConflict(true);
jqCustom( document ).ready(function($) {

$('main').delegate('[data-action-wishlist]','click', function( event ) {


  var prod_title = $(this).data('title');
  var prod_message ="Product added to wishlist";
  
  if($(this).hasClass('is--added')){
    prod_message ="Product removed from wishlist";
  }

  
  
  var toast_obj ={
    heading: prod_title,
    text: prod_message,
    hideAfter: 5000,
    position: 'top-right',
    bgColor: '#ffb3b9',
    textColor: '#101921',
    loaderBg:'#101921'
};
    

  $.toast(toast_obj)

  
});
  
function formatMoney(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
function ajaxify_gift_cart(){
  jqCustom.getJSON(window.Shopify.routes.root + 'products/gift-card.js', function(product) {
               $.ajax({
                	type: 'GET',
                	url: window.Shopify.routes.root+'cart.json',
                	dataType: 'jsonp',
                	success: function(data) { 
                		var item_count = data['item_count'];
                        var total_price = data['total_price'];
                      
                        // var format = document.querySelector('[data-money-format]').getAttribute('data-money-format');
                      var format = '{{amount_no_decimals}}';
                      
                      
                        $('.t4s-drawer__wrap .t4s-btn__checkout .text').text('$'+formatMoney(total_price,format)+' USD');
                		//If there are items in cart
                		if(item_count > 0) {

                           
                          var total_amount= formatMoney(total_price,format);
                          if(total_amount<100){
                            
                             var shipping_amount= 100 - total_amount;

                            
                            $.each(product['variants'], function(key,value) {
                                
                                if(key==shipping_amount - 1){
                                 
                                  $('.free-shipping').attr('data-variant-id',value['id']);
                                  
                                }

                            }); 
                          }
                          else{

                           
                          }
                          
                              
                          
                		}
                	}
                });
               
  });
}

function ajaxify_variant_assign(){
  $('[data-ntajax-container] .t4s-product-wrapper').each(function(){
     
     var data_available_variant =JSON.parse($(this).find('.data-available-product-assign').html());
      var data_current_variant =JSON.parse($(this).find('.data-current-product-assign').html());
    
    var data_current_variant_use =[];
    if(data_available_variant.length){
     
      data_current_variant_use = data_available_variant[0];
    }
    else{
      
      data_current_variant_use = data_current_variant;
    }
    
    window.dac = data_current_variant_use;
     // //console.log(data_current_variant_use['featured_image']['variant_ids']);
     // //var available_first_variant =data_current_variant_use['featured_image']['variant_ids'];

        try {
          
          var available_first_variant =data_current_variant_use['featured_image']['variant_ids'];
            $(this).find('.size-button').each(function(index){
        
               $(this).find('span').attr('data-variant-id',available_first_variant[index]);
      
            });
    
        } catch (e) {
              
          }


    
      


    
  

    
  });
}
const chunk = function(arr, size){
   const res = [];
   for(let i = 0; i < arr.length; i++) {
      if(i % size === 0){
         // Push a new array containing the current value to the res array
         res.push([arr[i]]);
      }
      else{
         // Push the current value to the current array
         res[res.length-1].push(arr[i]);
      };
   };
   return res;
};
function removeDuplicates(arr) {
        return arr.filter((item, 
            index) => arr.indexOf(item) === index);
    }

  
ajaxify_gift_cart();
$( document ).on( "imageLoadComplete", function( evt ) {
	      
         
 });
$( document ).on( "add:cart:success", function( evt ) {
 fetch(`${window.location.origin}/cart.js`)
  .then(res => res.clone().json().then(data => {
    var cart = {
      total_price: data.total_price/100,
      $value: data.total_price/100,
      total_discount: data.total_discount,
      original_total_price: data.original_total_price/100,
      items: data.items
    }
  // Do something with the cart object
    var addeditem = {};
  //console.log("Shopify Cart Object:",cart);

    $.each(cart.items, function(index, item) {
  if(index==0){
     var format = '{{amount_no_decimals}}';
    var p= '$'+formatMoney(item.price,format)+' USD';
   addeditem=  {
         "ProductID": item.product_id,
         "Name": item.product_title,
         "Brand": item.vendor,
         "Price":  p,
         "URL": 'https://www.luckyrose.com'+item.url,
         "ImageURL": item.image,
         "Categories": item.product_type
       };
     klAjax = true;
  }
      
});

    
    

     if (klAjax) {
      //console.log("Addedtocart klaviyo",addeditem);
        _learnq.push(['track', 'Added to Cart', addeditem]);
        klAjax = false;
      }

    

    }))

  
          ajaxify_gift_cart();
 });
$( document ).on( "change:ajaxCart", function( evt ) {
	     
          ajaxify_gift_cart();
  });
$( document ).on( "cart:updated", function( evt ) {
	      
          ajaxify_gift_cart();
  });
// $( document ).on( "click.remove", function( evt ) {
	      
//           ajaxify_gift_cart();
//           // ajaxify_variant_assign();
  
// });

  // $('[data-cart-items]').delegate('[data-action-change]','click.remove', function( event ) {
  //   console.log( evt ,'Click Remove');
  //         ajaxify_gift_cart();
  //   });
// $(".t4s-pr-grid.t4s-pr-style5 .t4s-product-colors > span")
//   .mouseenter(function() {

  
window.onload = function() {

setTimeout( function() { 
   
    ajaxify_variant_assign();
  
  }, 1000);
};
ajaxify_variant_assign();

var MutationObserver    = window.MutationObserver || window.WebKitMutationObserver;
var myElement = $("[data-ntajax-container]");

var observer = new MutationObserver(function(mutations) {

  console.log(mutations);
  console.log('Mutation ajaxify_variant_assign');
   ajaxify_variant_assign();
  
});

if(myElement.length)
{
 
  observer.observe(myElement[0], {attributes: false, childList: true, characterData: false, subtree:false});
}

/*Observer for cart change*/
var cartElement = $("[data-cart-wrapper]");
var observerCart = new MutationObserver(function(mutations) {

  // console.log(mutations);
  // console.log('Mutation ajaxify_variant_assign');
   ajaxify_gift_cart();
  
});

if(cartElement.length)
{
 
  observerCart.observe(cartElement[0], {attributes: true, childList: true, characterData: false, subtree:false});
}

  
$('[data-ntajax-container]').delegate('.t4s-pr-grid.t4s-pr-style5 .t4s-product-colors > span','mouseenter', function( event ) {
var hoveredcolor =$(this);
  var color_name = $(this).find('.t4s-pr-color__name').text().trim();
  console.log(color_name,"color name");
  var data_handle = $(this).closest('.t4s-product-wrapper').attr('data-product-handle');
  jQuery.getJSON(window.Shopify.routes.root + 'products/'+data_handle, function(data) {
    var  product = data.product;
    var variant_list = product.variants;
    console.log(product);
  console.log('The title of this product is ' + product.title);


    var length_size= hoveredcolor.closest('.t4s-product-wrapper').find(".t4s-product-sizes .size-button").length;
    hoveredcolor.closest('.t4s-product-wrapper').find(".t4s-product-sizes .size-button").each(function(index) {
          var size_button = $(this);
          var size_text = size_button.find('span').text().trim();
          $.each(variant_list, function(key,value) {
            
            console.log(size_text,value['option2']);
            console.log(size_text,value['option2']);

            
            if(size_text == value['option2'] || size_text == value['option1'] ){
              
               console.log(value['option2'],value['option1'],'Found------------');

              if(color_name==value['option2'] || color_name == value['option1']){

                console.log('Changed on ------------',color_name,value['id']);
                size_button.find('span').attr('data-variant-id',value['id']);
              }
              
               
            }
        
          });

     });








    
} );
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
 
   /* var color_name = $(this).find('.t4s-pr-color__name').text();
    // console.log($(this).find('.t4s-pr-color__name').text());
    var color_name = $(this).find('.t4s-pr-color__name').text();
     var data_variants = $(this).closest('.t4s-product-wrapper').find(".t4s-product-sizes").attr('data-variant-ajax');
     var data_variants_obj = $.parseJSON( data_variants );

    
      var color_count= data_variants_obj['color_count'];
      var variant_list= [];
       $.each(data_variants_obj['id_variants'], function(key,value) {
          variant_list.push(value);
      }); 
      var variant_grouped = chunk(variant_list,color_count);
      

      
    var variant_holder =[];
    var group='';
    
    $.each(data_variants_obj['color_variants'], function(color_key,color_value) {

     
      var group='';
     
       $.each(variant_grouped, function(variant_key,variant_value) {
           
             $.each(variant_value, function(item_key,item_value) {
                  
                if(color_key==item_key){
                  
                   group=  '{"color_value":"'+color_value+'","variant_value":"'+item_value+'"}';
                 
                   variant_holder.push(JSON.parse( group ));
                    
                 }
               
               });


        }); 

      
     
      
      });

 $.each(variant_holder, function(key,variant_value) {
     
      var length_size= hoveredcolor.closest('.t4s-product-wrapper').find(".t4s-product-sizes .size-button").length;
      hoveredcolor.closest('.t4s-product-wrapper').find(".t4s-product-sizes .size-button").each(function(index) {

        
           

           if(color_name === variant_value['color_value'] && key%length_size == index){
            
             



             
              $(this).find('span').attr('data-variant-id',variant_value['variant_value']);
           }
           else{
             
           }
        
        

     });
   

 });
*/
       
  });

  var sectionIds = $('.sidebar-wrap a.nav-link');
var svg =  $('.sidebar-container svg');
    $(document).scroll(function(){
     
          
        sectionIds.each(function(){

            var container = $(this).attr('href');
            var containerOffset = $(container).offset().top;
            var containerHeight = $(container).outerHeight();
            var containerBottom = containerOffset + containerHeight;
            var scrollPosition = $(document).scrollTop();

            if(scrollPosition < containerBottom - 90 && scrollPosition >= containerOffset - 90){
              //   console.log('scrollPosition:',scrollPosition);
              // console.log('containerOffset:',containerOffset);
              // console.log('containerBottom:',containerBottom);
               var inx = $(this).data('index');
              var style={
                "stroke-dashoffset": "1", 
                "stroke-dasharray": "1, 0, 37, 400",
                "opacity": "1"
              };
              if(inx==1){
                style={
                "stroke-dashoffset": "1", 
                "stroke-dasharray": "1, 0, 37, 400",
                "opacity": "1"
              };
                svg.find('path').css(style);
              }
              else if(inx==2){
              style={
                "stroke-dashoffset": "1", 
                "stroke-dasharray": "1, 50, 37, 400",
                "opacity": "1"
              };
                svg.find('path').css(style);
              }
              else if(inx==3){
                style={
                "stroke-dashoffset": "1", 
                "stroke-dasharray": "1, 112, 37, 400",
                "opacity": "1"
              };
                svg.find('path').css(style);
              }
              else if(inx==4){
                style={
                "stroke-dashoffset": "1", 
                "stroke-dasharray": "1, 170, 37, 400",
                "opacity": "1"
              };
                svg.find('path').css(style);
              }
              else if(inx==5){
                style={
                "stroke-dashoffset": "1", 
                "stroke-dasharray": "1, 220, 37, 400",
                "opacity": "1"
              };
                svg.find('path').css(style);
              }
              else if(inx==6){
                style={
                "stroke-dashoffset": "1", 
                "stroke-dasharray": "1, 264, 37, 400",
                "opacity": "1"
              };
                svg.find('path').css(style);
              }
              else if(inx==7){
                style={
                "stroke-dashoffset": "1", 
                "stroke-dasharray": "1, 307, 37, 400",
                "opacity": "1"
              };
                svg.find('path').css(style);
              }
              else if(inx==8){
                style={
                "stroke-dashoffset": "1", 
                "stroke-dasharray": "1, 353, 37, 400",
                "opacity": "1"
              };
                svg.find('path').css(style);
              }
              

                $(this).addClass('active');
            } else{
                $(this).removeClass('active');
            }
    
    
        });
    });
  
  
});